import { Icon } from "../../../components/BaseComponents/Icon";

export const EmptyStarIcon = (props) => (
	<Icon viewBox="0 0 24 24" fill="none" {...props}>
		<path
			xmlns="http://www.w3.org/2000/svg"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="2"
			d="M11.52 4.32A.52.52 0 0 1 12 4a.53.53 0 0 1 .48.32L14.46 9a.52.52 0 0 0 .44.32l5.12.4c.46.04.65.6.3.9l-3.9 3.3a.51.51 0 0 0-.17.51l1.19 4.93a.5.5 0 0 1-.2.54.53.53 0 0 1-.58.02l-4.39-2.64a.53.53 0 0 0-.54 0l-4.39 2.64a.53.53 0 0 1-.76-.26.5.5 0 0 1-.02-.3l1.2-4.93a.5.5 0 0 0-.17-.5l-3.9-3.3a.51.51 0 0 1-.16-.56.51.51 0 0 1 .45-.35l5.12-.4A.53.53 0 0 0 9.54 9l1.98-4.68Z"
		/>
	</Icon>
);
